export default __webpack_public_path__ + "static/media/my-day.c8f423a3.png";